"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MONTHS = exports.reduxActions = exports.sagaEvents = exports.ALLOWED_FIELD_TYPES = exports.APP_NAMESPACE = void 0;
exports.APP_NAMESPACE = "widgetEditor";
exports.ALLOWED_FIELD_TYPES = [{
  name: "esriFieldTypeSmallInteger",
  type: "number",
  provider: "esri"
}, {
  name: "esriFieldTypeInteger",
  type: "number",
  provider: "esri"
}, {
  name: "esriFieldTypeSingle",
  type: "number",
  provider: "esri"
}, {
  name: "esriFieldTypeDouble",
  type: "number",
  provider: "esri"
}, {
  name: "numeric",
  type: "number",
  provider: "psql"
}, {
  name: "number",
  type: "number",
  provider: "carto"
}, {
  name: "int",
  type: "number",
  provider: "psql"
}, {
  name: "integer",
  type: "number",
  provider: "psql"
}, {
  name: "float",
  type: "number",
  provider: "sql"
}, {
  name: "long",
  type: "number",
  provider: "sql"
}, {
  name: "double",
  type: "number",
  provider: "sql"
}, {
  name: "real",
  type: "number",
  provider: "sql"
}, {
  name: "decimal",
  type: "number",
  provider: "sql"
}, {
  name: "string",
  type: "string",
  provider: "sql"
}, {
  name: "char",
  type: "string",
  provider: "sql"
}, {
  name: "varchar",
  type: "string",
  provider: "sql"
}, {
  name: "esriFieldTypeString",
  type: "string",
  provider: "esri"
}, {
  name: "text",
  type: "string",
  provider: "elastic"
}, {
  name: "esriFieldTypeDate",
  type: "date",
  provider: "esri"
}, {
  name: "date",
  type: "date",
  provider: "sql"
}, {
  name: "time",
  type: "date",
  provider: "sql"
}, {
  name: "timestamp",
  type: "date",
  provider: "sql"
}, {
  name: "interval",
  type: "date",
  provider: "sql"
}, {
  name: "boolean",
  type: "boolean",
  provider: "sql"
}, {
  name: "array",
  type: "array",
  provider: "sql"
}];
exports.sagaEvents = {
  DATA_FLOW_STORE_ADAPTER_CONFIG: "".concat(exports.APP_NAMESPACE, "/SAGAS/DATA_FLOW/adapter_configuration"),
  DATA_FLOW_DATASET_WIDGET_READY: "".concat(exports.APP_NAMESPACE, "/SAGAS/DATA_FLOW/dataset_widget_ready"),
  DATA_FLOW_FIELDS_AND_LAYERS_READY: "".concat(exports.APP_NAMESPACE, "/SAGAS/DATA_FLOW/fields_and_layers_ready"),
  DATA_FLOW_DATA_READY: "".concat(exports.APP_NAMESPACE, "/SAGAS/DATA_FLOW/data_ready"),
  DATA_FLOW_VISUALIZATION_READY: "".concat(exports.APP_NAMESPACE, "/SAGAS/DATA_FLOW/visualisation_ready"),
  DATA_FLOW_PROXY_UPDATE: "".concat(exports.APP_NAMESPACE, "/SAGAS/DATA_FLOW/proxy_update"),
  EDITOR_SAVE: "".concat(exports.APP_NAMESPACE, "/CONFIGURATION/saveConfiguration"),
  DATA_FLOW_UPDATE_WIDGET: "".concat(exports.APP_NAMESPACE, "/SAGAS/DATA_FLOW/updateWidget"),
  DATA_FLOW_CONFIGURATION_UPDATE: "".concat(exports.APP_NAMESPACE, "/SAGAS/DATA_FLOW/configurationUpdate"),
  DATA_FLOW_UPDATE_HOOK_STATE: "".concat(exports.APP_NAMESPACE, "/SAGAS/DATA_FLOW/updateHookState"),
  DATA_FLOW_RESTORE: "".concat(exports.APP_NAMESPACE, "/SAGAS/DATA_FLOW/RESTORE"),
  DATA_FLOW_RESTORED: "".concat(exports.APP_NAMESPACE, "/SAGAS/DATA_FLOW/RESTORED"),
  DATA_FLOW_UNMOUNT: "".concat(exports.APP_NAMESPACE, "/SAGAS/DATA_FLOW/UNMOUNT")
};
exports.reduxActions = {
  EDITOR_SET_CONFIGURATION: "".concat(exports.APP_NAMESPACE, "/CONFIGURATION/setConfiguration"),
  EDITOR_PATCH_CONFIGURATION: "".concat(exports.APP_NAMESPACE, "/CONFIGURATION/patchConfiguration"),
  EDITOR_SET_WIDGETCONFIG: "".concat(exports.APP_NAMESPACE, "/WIDGETCONFIG/setWidgetConfig"),
  EDITOR_SET_FILTERS: "".concat(exports.APP_NAMESPACE, "/EDITOR/setFilters"),
  EDITOR_SET_END_USER_FILTERS: "".concat(exports.APP_NAMESPACE, "/EDITOR/setEndUserFilters")
};
exports.MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
exports["default"] = {
  MONTHS: exports.MONTHS,
  APP_NAMESPACE: exports.APP_NAMESPACE,
  ALLOWED_FIELD_TYPES: exports.ALLOWED_FIELD_TYPES,
  sagaEvents: exports.sagaEvents,
  reduxActions: exports.reduxActions
};